import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from 'components/Layout';
import Home from 'pages/Home';

// Home is in the main bundle (most visits start there); other routes load on demand.
const Category = lazy(() => import('pages/Category'));
const Product = lazy(() => import('pages/Product'));
const Search = lazy(() => import('pages/Search'));
const Cart = lazy(() => import('pages/Cart'));
const Checkout = lazy(() => import('pages/Checkout'));
const Payment = lazy(() => import('pages/Payment'));
const PaymentReturn = lazy(() => import('pages/PaymentReturn'));
const PayLink = lazy(() => import('pages/PayLink'));
const Track = lazy(() => import('pages/Track'));
const MyOrders = lazy(() => import('pages/MyOrders'));
const Unsubscribe = lazy(() => import('pages/Unsubscribe'));
const StaticPage = lazy(() => import('pages/StaticPage'));
const Articles = lazy(() => import('pages/Articles'));
const Article = lazy(() => import('pages/Article'));
const NotFound = lazy(() => import('pages/NotFound'));

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/kategori/:slug" element={<Category />} />
        <Route path="/produk/:slug" element={<Product />} />
        <Route path="/cari" element={<Search />} />
        <Route path="/keranjang" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/pembayaran/selesai" element={<PaymentReturn />} />
        <Route path="/pembayaran/:token" element={<Payment />} />
        <Route path="/bayar/:token" element={<PayLink />} />
        <Route path="/lacak/:token" element={<Track />} />
        <Route path="/pesanan-saya" element={<MyOrders />} />
        <Route path="/berhenti-langganan/:token" element={<Unsubscribe />} />
        <Route path="/halaman/:slug" element={<StaticPage />} />
        <Route path="/artikel" element={<Articles />} />
        <Route path="/artikel/:slug" element={<Article />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
